import { useState } from 'react';
import { PageHeading, PanelHeader, View } from '../../ui/View';

const format = (value: number) => value.toLocaleString('en-AU', { maximumFractionDigits: 1 });
const positive = (value: string) => Math.max(0, Number(value) || 0);

/**
 * Dilution calculator. Water to mix follows the label's application volume for the treated area; a typed water
 * volume is kept until the area or application volume changes, or the technician resets it.
 */
export function CalculatorView() {
  const [area, setArea] = useState('180');
  const [rate, setRate] = useState('5');
  const [coverage, setCoverage] = useState('10');
  const [customWater, setCustomWater] = useState<string | null>(null);
  const recommendedWater = positive(area) * positive(coverage) / 100;
  const water = customWater === null ? recommendedWater : positive(customWater);
  const chemical = water * positive(rate);

  return (
    <View id="calculator">
      <PageHeading eyebrow="Field tool" title="Chemical calculator" subtitle="Calculate dilution quantities from property area and the selected product label rate." />
      <section className="panel calculator">
        <div className="calculator-inputs">
          <PanelHeader title="Mix inputs" summary="Take the label rate and application volume from the product label." />
          <div className="panel-body form-grid">
            <label>Property area <span className="input-affix"><input id="propertyArea" type="number" min="0" inputMode="decimal" value={area} onChange={(event) => { setArea(event.target.value); setCustomWater(null); }} /><span>m²</span></span></label>
            <label>Label rate <span className="input-affix"><input id="labelRate" type="number" min="0" inputMode="decimal" value={rate} onChange={(event) => setRate(event.target.value)} /><span>mL/L</span></span></label>
            <label>Application volume <span className="input-affix"><input id="applicationVolume" type="number" min="0" step="0.1" inputMode="decimal" value={coverage} onChange={(event) => { setCoverage(event.target.value); setCustomWater(null); }} /><span>L / 100 m²</span></span></label>
            <label>Water volume to mix <span className="input-affix"><input id="waterVolume" type="number" min="0" step="0.1" inputMode="decimal" value={customWater ?? recommendedWater.toFixed(1).replace(/\.0$/, '')} onChange={(event) => setCustomWater(event.target.value)} /><span>L</span></span></label>
          </div>
        </div>
        <output className="calculator-result" htmlFor="propertyArea labelRate applicationVolume waterVolume">
          <span className="eyebrow">Required chemical</span>
          <strong id="chemicalResult">{format(chemical)} mL</strong>
          <small id="chemicalWaterDetail">
            {customWater === null ? `Mixed into ${format(recommendedWater)} L of water (recommended for this area).` : <>Custom mix: {format(water)} L of water. <button type="button" className="btn-link" onClick={() => setCustomWater(null)}>Use recommended</button></>}
          </small>
        </output>
      </section>
    </View>
  );
}
